<template>
  <button class="clear-btn" title="Close chat window" @click="chatBotStore.toggleChat()">x</button>
</template>
<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();
</script>
